import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import Image from 'react-bootstrap/Image'
import AboutService from '../services/AboutService'
import LoadingContainer from '../components/common/LoadingContainer'

function About() {
  const [data, setData] = React.useState({})
  const [loading, setLoading] = React.useState(false)

  const { about_company, ceo_message, image_url } = data || {}

  React.useEffect(() => {
    getAboutPageData()
  }, [])
  const getAboutPageData = async () => {
    setLoading(true)
    try {
      const response = await AboutService.getAboutData()
      setData(response?.data || {})
      // console.log(response)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }
  return (
    <LoadingContainer loading={loading}>
      <Container className='py-4'>
        <div
          style={{ fontSize: 30 }}
          className='text-success text-center my-5 pt-2'
        >
          ABOUT US
        </div>
        <Row className='position-relative '>
          {image_url && (
            <Col md={3} className='mb-4'>
              <Image
                width={'100%'}
                src={
                  image_url ||
                  'https://st4.depositphotos.com/13193658/30158/i/450/depositphotos_301587484-stock-photo-handsome-businessman-formal-wear-glasses.jpg'
                }
                style={{ aspectRatio: 1, objectFit: 'contain' }}
              />
            </Col>
          )}
          {ceo_message && (
            <Col md={9} className='mb-4'>
              <h5 className='color-theme text-bold mb-4'>CEO's message</h5>
              <p>{ceo_message}</p>
            </Col>
          )}
          {about_company && (
            <Col xs={12}>
              <div className='my-5'>
                <h5 className='color-theme text-bold mb-4'>
                  About Our Company
                </h5>
                <p>{about_company}</p>
              </div>
            </Col>
          )}
          <Col>
            <div className='my-5'>
              {/* <h5 className='color-theme text-bold mb-4'>Photo Gallery </h5> */}
            </div>
          </Col>
        </Row>
      </Container>
    </LoadingContainer>
  )
}

export default About
